'use strict';

module.exports = {
  API_ORIGIN: 'https://api.mapbox.com',
  EVENT_PROGRESS_DOWNLOAD: 'downloadProgress',
  EVENT_PROGRESS_UPLOAD: 'uploadProgress',
  EVENT_ERROR: 'error',
  EVENT_RESPONSE: 'response',
  ERROR_HTTP: 'HttpError',
  ERROR_REQUEST_ABORTED: 'RequestAbortedError'
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/@mapbox/mapbox-sdk/lib/constants.js
 ** module id = 61
 ** module chunks = 0
 **/